import { axios } from "helper/axios";
import { PHCOnboardingConstants } from "./PHCOnboardingConstants";
import { PHCDashboardApis } from "../PHCDashoard/PHCDashboardApis";

const PHCOnboardingApis = {};

PHCOnboardingApis.getOnboardingData = () => {
  return axios.get(PHCOnboardingConstants.PHC_ONBOARDING_DATA_API);
};

PHCOnboardingApis.uploadExcel = (file) => {
  const formData = new FormData();
  formData.append("portfolioAttachment", file);
  return axios.post(PHCOnboardingConstants.PHC_UPLOAD, formData);
};

PHCOnboardingApis.getUploadedExcelPreview = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.LISTING_UPLOAD_PORTFOLIO}?portfolioId=${id}`,
  );
};
PHCOnboardingApis.getCompanyListPreview = () => {
  return axios.get(PHCOnboardingConstants.GET_COMPANY_LIST);
};

PHCOnboardingApis.uploadedExcelUpdate = (payload) => {
  return axios.put(PHCOnboardingConstants.PHC_UPLOADED_UPDATE, payload);
};

PHCOnboardingApis.phcOnboardPreview = () => {
  return axios.post(PHCOnboardingConstants.PHC_ONBOARD_PREVIEW);
};

PHCOnboardingApis.getGraphData = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_PORTFOLIO_GRAPH_DETAILS}?portfolioId=${id}`,
  );
};

PHCOnboardingApis.regenerateReport = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_REGENERATE}?portfolioId=${id}`,
    { skipErrorToast: true },
  );
};

PHCOnboardingApis.getGrapDataPRLP = (id) => {
  return axios.get(`${PHCOnboardingConstants.PHC_PRLP}?portfolioId=${id}`);
};
PHCOnboardingApis.getGrapDataPerforamnceChart = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_PERFORMANCE_CHART}?portfolioId=${id}`,
  );
};
PHCOnboardingApis.getGrapDataSJS = (id) => {
  return axios.get(`${PHCOnboardingConstants.PHC_SJS}?portfolioId=${id}`);
};

PHCOnboardingApis.getPortfolioHighlights = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_PORTFOLIO_HIGHLIGHTS}?portfolioId=${id}`,
  );
};

PHCOnboardingApis.getSectorDiversification = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_SECTOR_DIVERSIFICATION}?portfolioId=${id}`,
  );
};

PHCOnboardingApis.getLiquidityAnalysis = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_LIQUIDITY_ANALYSIS}?portfolioId=${id}`,
  );
};

PHCOnboardingApis.getPerformanceAnalytics = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_PERFORMANCE_ANALYTICS}?portfolioId=${id}`,
  );
};

PHCOnboardingApis.getRecommendProduct = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_RECOMMEND_PRODUCT}?portfolioId=${id}`,
  );
};

PHCOnboardingApis.getAiRecommend = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_AI_RECOMMEND}?portfolioId=${id}`,
  );
};

PHCOnboardingApis.getPortfolioReview = (id) => {
  return axios.get(
    `${PHCOnboardingConstants.PHC_PORTFOLIO_REVIEW}?portfolioId=${id}`,
  );
};

PHCDashboardApis.getDownloadExcelPhc = () => {
  return axios.get(PHCOnboardingConstants.PHC_DOWNLOAD_EXCEL, {
    responseType: "arraybuffer",
  });
};

PHCOnboardingApis.phcHealthGenerate = (payload) => {
  return axios.post(PHCOnboardingConstants.PHC_GENERATE, payload);
};

PHCOnboardingApis.deletePortfolioItem = (id) => {
  return axios.delete(
    `${PHCOnboardingConstants.PHC_PREVIEWSTOCK_DELETE}/${id}`,
  );
};

PHCOnboardingApis.saveReport = (payload) => {
  return axios.post(PHCOnboardingConstants.PHC_SAVE_REPORT, payload);
};

PHCOnboardingApis.initiateDocumentSigning = () => {
  return axios.post(PHCOnboardingConstants.PHC_INITIATE_DOCUMENT_SIGNING_API);
};

PHCOnboardingApis.redirectOnboarding = () => {
  return axios.post(PHCOnboardingConstants.PHC_DASHBOARD_REDIRECT_API);
};

// Navia
PHCOnboardingApis.getOneMoneyRedirectUrl = () => {
  return axios.get(PHCOnboardingConstants.ONE_MONEY_REDIRECT_URL_API);
};

// consent id
PHCOnboardingApis.getConsentId = (payload) => {
  return axios.post(PHCOnboardingConstants.PHC_GET_CONSENT_ID_API, payload);
};

// CKYC redirect
PHCOnboardingApis.redirectToCkyc = () => {
  return axios.get(PHCOnboardingConstants.PHC_CKYC_REDIRECT_API);
};

export { PHCOnboardingApis };
